.visibility-1{background-color:#5a42d0}.visibility-0\.5{background-image:repeating-linear-gradient(135deg,#5a42d080,#5a42d080 5px,#5a42d0 5px 10px)}.visibility-0{background-color:#f6f6f6;visibility:inherit}
/*# sourceMappingURL=visibility.css.map */
